/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Merchant,
    MerchantFromJSON,
    MerchantFromJSONTyped,
    MerchantToJSON,
} from './';

/**
 * 
 * @export
 * @interface ListMerchantsResponse
 */
export interface ListMerchantsResponse {
    /**
     * 
     * @type {Array<Merchant>}
     * @memberof ListMerchantsResponse
     */
    merchants?: Array<Merchant>;
}

export function ListMerchantsResponseFromJSON(json: any): ListMerchantsResponse {
    return ListMerchantsResponseFromJSONTyped(json, false);
}

export function ListMerchantsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListMerchantsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'merchants': !exists(json, 'merchants') ? undefined : ((json['merchants'] as Array<any>).map(MerchantFromJSON)),
    };
}

export function ListMerchantsResponseToJSON(value?: ListMerchantsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'merchants': value.merchants === undefined ? undefined : ((value.merchants as Array<any>).map(MerchantToJSON)),
    };
}


